import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useState } from 'react';
import { Button, IconTitle, ScrollableContainer, TabPanel } from '.';
import ConfirmationDialog from './ConfirmationDialog';

interface CondominiumTabPanelProps {
  title: string;
  children: JSX.Element | JSX.Element[];
  visible: boolean;
  loading: boolean;
  mustConfirm?: boolean;
  mustConfirmContent?: string;
  disabled?: boolean;
  direction?: 'right' | 'left';
  hiddenSubmit?: boolean;
  customSubmit?: JSX.Element;
  onClickSubmit?: () => void;
  onClickClose: () => void;
}

const useStyles = makeStyles(({ spacing, palette }: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    overflowY: 'auto',
  },

  titleContainer: {
    padding: `${spacing(2)} 0`,
  },

  closeButton: {
    marginTop: spacing(4),
  },

  submitButton: {
    marginTop: spacing(3),
    display: 'flex',
    flexDirection: 'column',
  },

  closeText: {
    color: palette.neutral[100],
    fontSize: '0.875rem',
    textTransform: 'uppercase',
  },
}));

export const ScrollableTabPanel = ({
  children,
  title,
  visible,
  loading,
  hiddenSubmit = false,
  customSubmit,
  mustConfirm = false,
  mustConfirmContent = 'Deseja continuar esta operação?',
  disabled,
  direction,
  onClickClose,
  onClickSubmit,
}: CondominiumTabPanelProps): JSX.Element => {
  const styles = useStyles();
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  const handleSubmit = () => {
    if (mustConfirm) {
      setDialogOpen(true);
      return;
    }
    if (onClickSubmit) {
      onClickSubmit();
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleAccept = () => {
    if (onClickSubmit) {
      onClickSubmit();
    }
    setDialogOpen(false);
  };

  return (
    <>
      <TabPanel direction={direction ?? 'left'} visible={visible}>
        <div className={styles.container}>
          <div className={styles.titleContainer}>
            <IconTitle title={title} />
          </div>
          <ScrollableContainer>{children}</ScrollableContainer>
          {!hiddenSubmit && (
            <div className={styles.submitButton}>
              <Button
                disabled={disabled}
                onClick={() => {
                  handleSubmit();
                }}
                loading={loading}
              >
                Continuar
              </Button>
            </div>
          )}
          {customSubmit && <div className={styles.submitButton}>{customSubmit}</div>}
          <div className={styles.closeButton}>
            <Button variant="text" onClick={onClickClose}>
              <span className={styles.closeText}>Fechar</span>
            </Button>
          </div>
        </div>
      </TabPanel>
      <ConfirmationDialog
        open={dialogOpen}
        content={mustConfirmContent}
        onClose={handleCloseDialog}
        onCancel={handleCloseDialog}
        onAccept={handleAccept}
      />
    </>
  );
};

export default ScrollableTabPanel;
